module.exports = __webpack_public_path__ + "static/media/3.b5a4cbc8.svg";